/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import OrderItemsTable from './OrderItemsTable/OrderItemsTable'
import OrderItemsRich from './OrderItemsRich/OrderItemsRich'
import { useState } from 'react'
import { convertOrderItemsToFulfillmentIssues } from '../../../../services/Order/Order.service'
import { OrderPickingScanProvider } from '../OrderScanPicking'
import { useSaveFulfillment } from './OrderItemFulfillment/useSaveFulfillment'


const orderItemsListDisplayMode = {
    LINES: 1,
    PRODUCTS: 2,
}

const OrderItemsList = ({displayMode, order, orderItems, orderItemListRef}) => {
    const [orderItemsWithFulfillmentIssues, setOrderItemsWithFulfillmentIssues] = useState([])
    const [orderItemsReplacements, setOrderItemsReplacements] = useState([])
    const {saveFulfillmentIssuesMutation} = useSaveFulfillment(order.id)

    const clearOrderItemFulfillmentIssue = (orderItem) => {
        const fulfillmentIssuesWithoutOrderItem = orderItemsWithFulfillmentIssues.filter(p => p.id !== orderItem.id)
        setOrderItemsWithFulfillmentIssues(fulfillmentIssuesWithoutOrderItem)

        const fulfillmentIssues = convertOrderItemsToFulfillmentIssues(fulfillmentIssuesWithoutOrderItem, orderItemsReplacements)
        saveFulfillmentIssuesMutation.mutate({fulfillmentIssues})
    }

    const addOrderItemToFulfillmentIssues = (oi, newQuantity, substitution = null) => {
        const getNewOrderFulfillmentIssues = () => {
            const otherItems = orderItemsWithFulfillmentIssues.filter(p => p.id !== oi.id)
            const orderItemToUpdate = {...orderItems.find(orderItem => orderItem.id === oi.id)}
            orderItemToUpdate.quantity = newQuantity
            return otherItems.concat([orderItemToUpdate])
        }

        const newOrderFulfillmentIssues = getNewOrderFulfillmentIssues()

        setOrderItemsWithFulfillmentIssues(newOrderFulfillmentIssues)

        let fulfillmentIssues = convertOrderItemsToFulfillmentIssues(newOrderFulfillmentIssues, orderItemsReplacements)
        if (substitution) {
            const getOrderItemsReplacements = () => {
                const otherItems = orderItemsReplacements.filter(p => p.fulfillmentIssueParentId !== oi.id)
                const orderItemToUpdate = {...orderItems.find(orderItem => orderItem.id === oi.id)}

                const orderItemToCreate = {
                    fulfillmentIssueParentId: orderItemToUpdate.id,
                    name: substitution.name,
                    image: substitution.image,
                    unitPrice: substitution.unitPrice,
                    quantity: substitution.quantity,
                    itemId: substitution.itemId,
                    substitutionId: substitution.substitutionId,
                    scanned: substitution.scanned,
                }

                return otherItems.concat([orderItemToCreate])
            }
            const newOrderItemsReplacements = getOrderItemsReplacements()
            setOrderItemsReplacements(newOrderItemsReplacements)
            fulfillmentIssues = convertOrderItemsToFulfillmentIssues(newOrderFulfillmentIssues, newOrderItemsReplacements)
        }

        saveFulfillmentIssuesMutation.mutate({fulfillmentIssues})
    }

    return (
      <OrderPickingScanProvider
        order={order}
        onFulfillmentIssue={addOrderItemToFulfillmentIssues}
        clearFulfillmentIssue={clearOrderItemFulfillmentIssue}
      >
          <div css={css`margin-top: 10px; margin-bottom: 1rem;`} ref={orderItemListRef}>
              {displayMode === orderItemsListDisplayMode.PRODUCTS ?
                <OrderItemsRich
                  order={order}
                  hideable
                />
                :
                <OrderItemsTable
                  order={order}
                />}
          </div>
      </OrderPickingScanProvider>
    )
}

export { OrderItemsList, orderItemsListDisplayMode }
